export const KIJS = 'DEPKL'; //'JSRA'; / LAU8

export const RESOLUTIONS = [156543.03392800014,
	  78271.516963999937,
	  39135.758482000092,
	  19567.879240999919,
	  9783.9396204999593,
	  4891.9698102499797,
	  2445.9849051249898,
	  1222.9924525624949,
	  611.49622628137968,
	  305.74811314055756,
	  152.87405657041106,
	  76.437028285073239,
	  38.21851414253662,
	  19.10925707126831,
	  9.5546285356341549,
	  4.7773142679493699,
	  2.3886571339746849,
	  1.1943285668550503,
	  0.59716428355981721,
	  0.29858214164761665];
export const API_SERVICE_HOST = 'https://maps.kartes.lv/';
export const SEARCH_API = API_SERVICE_HOST + "kijs/v3/" + KIJS + "/api/search";
export const CMS_URL = "https://cms.kartes.lv";
export const IMG_PATH = '/backend/public/image/';

export const PIE_AUTOSIZE_MAX_ZOOM = 15;

// should be the same as levelGroupMap in backend
// if zoomgroup changes dooring zoom, data is re-fetched from backend
export const DEFAULT_ZOOM_GROUPS = [
	[4, 5, 6, 7, 8],
	[9, 10],
	[11, 12],
	[13],
	[14, 15, 16, 17, 18]
];

export const gdhKey = 'eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI1OSIsInRzIjoxNTYxNDQ4NDA3Nzk0LCJpc3MiOiJodHRwOi8vcmVhY2gtdS5jb20ifQ.0_zXVQ0ybcAP7R3oPzEKnrSlvHQ4kqscAQyp8kmEoSk';

export const protocol = 'https';
export const PIE_DONUT_TRESHOLD = 160;
export const COLORS = {
	BLUEGRAY: '#427175',
	ORANGE:'#f49542',
	ORANGEDARK: '#b54711',
	ORANGELIGHT: '#f49542',
	RED:'#ff2323',
	DARKRED:'#840000',
	PURPLE:'#9743db',
	GREEN:'#7fd191',
	VIOLET: '#673ab7',
	GRAY:'#636363',
	LIGHTRED: '#8e5959',
	DARKBLUE: '#3a4571',
	BLUE: '#6394d4',
	LIGHTBLUE: '#c6d1fd',
	LIGHTBLUETRANSP: 'rgba(135, 152, 218, 0.8)',
	PLASTICGREEN: '#008290'
}
export const TEXT_ALL_MUNICIP = 'VISAS PAŠVALDĪBAS';

export const gdhServiceHost = '//api.geodatahub.eu';
export const apiServiceHost = '//maps.kartes.lv';

export const alphabetArray = [
	'a', 'ā', 'b', 'c', 'č', 'd', 'e', 'ē', 'f', 'g', 'ģ', 'h', 'i', 'ī', 'j', 'k', 'ķ',
	'l', 'ļ', 'j', 'm', 'n', 'ņ', 'o', 'p', 'r', 's', 'š', 't', 'u', 'ū', 'z', 'ž'
];



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/config.js